import { QueryClient } from '@tanstack/react-query';

declare global {
  interface Window {
    cliengo_query_client: QueryClient;
  }
}

export class QueryClientSingleton {
  private static instance: QueryClientSingleton;
  private client: QueryClient;
  
  private constructor() {
    this.client = new QueryClient();
  }
  
  public static getInstance(): QueryClientSingleton {
    if (!QueryClientSingleton.instance) {
      QueryClientSingleton.instance = new QueryClientSingleton();
    }
    return QueryClientSingleton.instance;
  }
  
  public getClient() {
    return this.client;
  }
}

export const getQueryClient = (client?: QueryClient) => {
  if (window.cliengo_query_client) {
    return window.cliengo_query_client;
  }
  
  if (client) {
    return client;
  }
  
  return QueryClientSingleton.getInstance().getClient();
};

export const invalidateQuery = (queryKey: string[]) => {
  return getQueryClient().invalidateQueries({
    queryKey,
  });
};
